<template>
  <div class="page">
    <!-- 检索 start -->
    <div class="sourceTop">
      <div class="searchBox">
        <input type="text" class="searchIpt" :value="keyword" :placeholder="'在'+ collectionCountText +'条馆藏中检索'" @input="inputChange" @keyup.enter="requestMenu">
        <div class="btn-search" @click="requestMenu" />
      </div>
    </div>
    <!-- 检索 end -->

    <!-- 筛选框 start -->
    <div class="clasifyBox">
      <span href="javascript:;" :class="{filtOpened:isOpened==1}" class="btn-cla" @click="isOpened=1" />
      <div class="classified">
        <a v-if="displayMenus.commitBy.name == '' && displayMenus.specialSubject.name == '' && displayMenus.categoryId.name == '' && displayMenus.subjects.name == '' && displayMenus.permissionRanges.name == '' && displayMenus.copyrightOwner.name == '' && displayMenus.collectionLevel.name==''">全部馆藏</a>
        <a v-if="displayMenus.categoryId.name && displayMenus.categoryId.name != ''">{{ displayMenus.categoryId.name }}</a>
        <a v-if="displayMenus.subjects.name && displayMenus.subjects.name != ''">{{ displayMenus.subjects.name }}</a>
        <a v-if="displayMenus.permissionRanges.name && displayMenus.permissionRanges.name != ''">{{ displayMenus.permissionRanges.name }}</a>
        <a v-if="displayMenus.copyrightOwner.name && displayMenus.copyrightOwner.name != ''">{{ displayMenus.copyrightOwner.name }}</a>
        <a v-if="displayMenus.collectionLevel.name && displayMenus.collectionLevel.name != ''">{{ displayMenus.collectionLevel.name }}</a>
        <a v-if="displayMenus.specialSubject.name && displayMenus.specialSubject.name != ''">{{ displayMenus.specialSubject.name }}</a>
        <a v-if="displayMenus.commitBy.name && displayMenus.commitBy.name != ''">{{ displayMenus.commitBy.name }}</a>
      </div>

      <!-- 全部分类 start -->
      <div v-show="isOpened==1" class="all-Classify">
        <!-- 包裹分类项的wrap start -->
        <div class="wrap">
          <div v-if="categorys" class="itm">
            <h3 class="digTit">分类</h3>
            <div class="items">
              <a v-for="(cate,idx) in categorys" :key="idx" :class="menuDisplay.categoryId.first.current == cate.id?'act':''" @click="selctFirstCate(cate)">{{ cate.cateName }}</a>
            </div>
            <div v-if="secondCate" class="items">
              <a v-for="(cate,idx) in secondCate" :key="idx" :class="menuDisplay.categoryId.second.current == cate.id?'act':''" @click="selectSecondCate(cate)">{{ cate.cateName }}</a>
            </div>
            <div v-if="thirdCate" class="items">
              <a v-for="(cate,idx) in thirdCate" :key="idx" :class="menuDisplay.categoryId.third.current == cate.id?'act':''" @click="selectThirdCate(cate)">{{ cate.cateName }}</a>
            </div>
          </div>
          <div v-if="subjects" class="itm">
            <h3 class="digTit">学科</h3>
            <div class="items">
              <a v-for="(cate,idx) in subjects" :key="idx" :class="menuDisplay.subjects.first.current == cate.id?'act':''" @click="selctFirstSubject(cate)">{{ cate.subjectName }}</a>
            </div>
            <div v-if="secondSubject" class="items">
              <a v-for="(cate,idx) in secondSubject" :key="idx" :class="menuDisplay.subjects.second.current == cate.id?'act':''" @click="selectSecondSubject(cate)">{{ cate.subjectName }}</a>
            </div>
            <div v-if="thirdSubject" class="items">
              <a v-for="(cate,idx) in thirdSubject" :key="idx" :class="menuDisplay.subjects.third.current == cate.id?'act':''" @click="selectThirdSubject(cate)">{{ cate.subjectName }}</a>
            </div>
          </div>

          <div v-if="menuData && menuData.collectionLevel" class="itm">
            <h3 class="digTit">馆藏级别</h3>
            <div class="items">
              <a v-for="(cate,idx) in menuData.collectionLevel" :key="idx" :class="menuDisplay.collectionLevel.current == cate.dictKey?'act':''" @click="selectLevel(cate)">{{ cate.dictValue }}</a>
            </div>
          </div>
          <div v-if="menuData && menuData.copyright" class="itm">
            <h3 class="digTit">版权</h3>
            <div class="items">
              <a v-for="(cate,idx) in menuData.copyright" :key="idx" :class="menuDisplay.copyrightOwner.current == cate.dictKey?'act':''" @click="selectCopyright(cate)">{{ cate.dictValue }}</a>
            </div>
          </div>
          <div v-if="menuData && menuData.scopeOfAuthorization" class="itm">
            <h3 class="digTit">权限范围</h3>
            <div class="items">
              <a v-for="(cate,idx) in menuData.scopeOfAuthorization" :key="idx" :class="menuDisplay.permissionRanges.current == cate.dictKey?'act':''" @click="selectRange(cate)">{{ cate.dictValue }}</a>
            </div>
          </div>
          <!-- <div v-if="resourceTypes" class="itm">
            <h3 class="digTit">资源类型</h3>
            <div class="items">
              <a v-for="(t, idx) in resourceTypes" :key="idx" :class="currentFileType&&currentFileType.dictKey==t.dictKey?'act':''" @click="selectFileType(t)">{{ t.dictValue }}</a>
            </div>
          </div> -->
        </div>
        <!-- 包裹分类项的wrap start -->
        <!-- cla-foot start -->
        <div class="cla-foot">
          <button class="btn btn-cancel" @click="clean">清空</button>
          <button class="btn btn-choose" @click="isOpened=0">在 {{ totalCount }} 条馆藏中检索</button>
        </div>
        <!-- cla-foot end -->
      </div>
      <!-- 全部分类 end -->
    </div>
    <!-- 筛选框 end -->

    <!-- 数字特藏 start -->
    <div class="digColl">
      <!-- digList start -->
      <div v-if="records.length" v-infinite-scroll="loadMore" class="digList" :infinite-scroll-distance="20" :infinite-scroll-disabled="disabled" style="overflow:auto">

        <div v-for="(item, index) in records" :key="index" class="itm" @click="toDetail(item)">
          <div class="itm-top">
            <h4 class="t">{{ item.name }}</h4>
            <p class="desc">{{ item.description }}</p>
            <!-- <div class="img" :style="{background:'url(' + item.preview +')','background-position':'center','background-size':'cover'}"> -->
            <div class="img">
              <el-image :src="item.preview" :fit="cover" />
            </div>
          </div>
          <div class="entLabel">
            <span v-if="item.pictureNumber>0 || item.videoNumber>0 || item.audioNumber>0">
              <em v-if="item.pictureNumber>0">{{ item.pictureNumber }}图片</em>
              <em v-if="item.videoNumber>0">{{ item.videoNumber }}视频</em>
              <em v-if="item.audioNumber>0">{{ item.audioNumber }}音频</em>
            </span>
            <span v-for="(cate,index) in item.listCategory" :key="index" class="cateType"><em>{{ cate.cateName || '-' }} </em><em>/</em></span>

          </div>
        </div>
        <p v-if="loading" class="reqtip">加载中...</p>
        <p v-if="noMore" class="reqtip">没有更多了</p>
      </div>
      <!-- digList end -->

    </div>
    <!-- 数字特藏 end -->

    <!-- 导航 start -->
    <div class="naviPosition" />
    <div class="digNavigate">
      <router-link class="navItm" :to="{ name: 'Waphome' }">
        <img src="../../../images/home.png" class="img-normal">
        <img src="../../../images/home_select.png" class="img-active">
        <label>首页</label>
      </router-link>
      <router-link class="navItm active" :to="{ name: 'Waplist' }">
        <img src="../../../images/res.png" class="img-normal">
        <img src="../../../images/res_select.png" class="img-active">
        <label>{{clients.collectionTheme?clients.collectionTheme:'特藏'}}</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapcertified' }">
        <img src="../../../images/upload.jpg" class="img-normal">
        <img src="../../../images/upload_select.jpg" class="img-active">
        <label>上传</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapuser' }">
        <img src="../../../images/use.png" class="img-normal">
        <img src="../../../images/use_select.png" class="img-active">
        <label>我的</label>
      </router-link>
    </div>
    <!-- 导航 end -->
  </div>
</template>

<script>
import api from '../../../api/collections.js'
import searchmodel from '../../../models/search.js'
import user from '../../../models/user.js'
import commapi from '../../../api/common.js'
import homeApi from "../../../api/home.js";
import {
  mapState
} from 'vuex'

export default {
  name: 'Waplist',
  data() {
    return {
      // keyword: searchmodel.keyword,
      clients: {},
      isOpened: '0',
      collData: null,
      records: [],
      menuDisplay: {
        permissionRanges: {
          current: ''
        },
        copyrightOwner: {
          current: ''
        },
        collectionLevel: {
          current: ''
        },
        categoryId: {
          first: {
            current: ''
          },
          second: {
            current: ''
          },
          third: {
            current: ''
          }
        },
        subjects: {
          first: {
            current: ''
          },
          second: {
            current: ''
          },
          third: {
            current: ''
          }
        }
      },
      displayMenus: {
        categoryId: {
          name: ''
        },
        subjects: {
          name: ''
        },
        permissionRanges: {
          name: ''
        },
        copyrightOwner: {
          name: ''
        },
        collectionLevel: {
          name: ''
        },
        specialSubject: {
          name: ''
        },
        commitBy: {
          name: ''
        }
      },
      menuData: null,
      pageIndex: 1,
      pageSize: 25,
      totalCount: 0,
      totalPage: 0,
      tipsOver: false,
      cover: 'cover',
      loading: false,
      // 资源类型
      testFileTypes: [{
        dictValue: '图片',
        dictKey: 1
      }, {
        dictValue: '视频',
        dictKey: 2
      }, {
        dictValue: '音频',
        dictKey: 3
      }, {
        dictValue: '文件',
        dictKey: 4
      }],

      categorys: null,
      secondCate: null,
      thirdCate: null,

      subjects: null,
      secondSubject: null,
      thirdSubject: null,
      resourceTypes: null,

      currentFileType: null,
      searchParams: { current: 1, size: 25, search: '', sortType: 4 },
      collectionCountText: ''
    }
  },
  computed: { // 下拉加载更多
    noMore() {
      return this.pageIndex >= this.totalPage
    },
    disabled() {
      return this.loading || this.noMore
    },
    ...mapState({
      keyword: state => state.search.keyword
    })
  },
  created(){
    this.requestclient();
  },
  mounted() {
    if (searchmodel.viewData) {
      const key = searchmodel.viewData.type
      this.searchParams.current = 1
      console.log('this.searchParams',searchmodel.viewData)
      if (!searchmodel.viewData.display) {
        this.searchParams = {
          search: searchmodel.keyword,
          current: 1,
          size: 24,
        }
        this.requestMenu()

        // this.research()
        console.log('搜索关键词进入')
      } else{
        this.searchParams[key] = searchmodel.viewData.params[key]
        this.displayMenus[key].name = searchmodel.viewData.display
       this.requestMenu()
      }
      
      searchmodel.viewData = null
    } else {
      if (!this.menuData) {
        this.requestMenu()
      }
    }
  },
  activated() {
    if (searchmodel.viewData) {
      const key = searchmodel.viewData.type
      this.searchParams.current = 1
      if (searchmodel.viewData.display) {
        this.searchParams[key] = searchmodel.viewData.params[key]
        this.displayMenus[key].name = searchmodel.viewData.display
      } else {
        this.searchParams.search = this.$store.state.search.keyword
      }

      this.requestMenu()
      searchmodel.viewData = null
    } else {
      if (!this.menuData) {
        this.requestMenu()
      }
    }
    this.requestAccount()
    document.querySelector('.digList').scrollTop = sessionStorage.getItem(this.$options.name) || 0
    sessionStorage.setItem(this.$options.name, 0)
  },
  methods: {
     //获取应用信息
    requestclient() {
      const that = this;
      
       homeApi.requestclient({ tenantId: this.$store.getters.tenantId })
        .then(r => {
          that.clients = r.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    requestSearch(append) { // 搜索查询
      const that = this
      this.searchParams.tenantId = this.$store.getters.tenantId
      api.searchColl(this.searchParams).then(r => {
        r.data.records.forEach(s => {
          s['name'] = s.collectionName + (s.subtitle ? ('-' + s.subtitle) : '') + (s.chapter ? ('-' + s.chapter) : '')
        })
        that.collData = r.data
        if (append) {
          that.records = that.records.concat(r.data.records)
        } else {
          that.records = r.data.records
        }
        that.totalCount = r.data.total
        that.totalPage = r.data.pages
        that.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    loadMore() { // 下拉加载更多
      this.loading = true
      const that = this
      var idx = that.pageIndex + 1
      var total = that.totalPage
      if (idx > total) {
        console.log('没有更多了...')
        this.noMore = true
        return
      }
      this.pageIndex += 1
      this.searchParams.current = idx
      this.searchParams.size = 25
      this.requestSearch(true)
    },
    requestAccount() { // 查询资源数据
      const that = this
      commapi.collectionCount({ tenantId: this.$store.getters.tenantId }).then(r => {
        that.collectionCountText = r.data
      })
    },
    requestMenu() { // 分类按钮查询
      // this.searchParams = {
      //   search: this.keyword,
      //   current: 1,
      //   size: 24
      // }
      this.requestSearch()
      const that = this
      const menuParams = {
        searchKey: this.keyword,
        size: 5,
        current: 1
      }
      for (const key in this.searchParams) {
        if (key === 'current' || key === 'size' || key === 'search' || key === 'sortType') {
          continue
        } else {
          menuParams[key] = this.searchParams[key]
        }
      }
      menuParams.tenantId = this.$store.getters.tenantId
      api.keyMemu(menuParams).then(r => {
        that.menuData = r.data
        that.categorys = that.menuData.sideNavigation
        that.subjects = that.menuData.subjectNavigation
        that.resourceTypes = r.data.resourceType
      }).catch(error => {
        console.error(error)
      })
    },
    // 分类选择
    selctFirstCate(v) {
      if (this.menuDisplay.categoryId.first.current === v.id) {
        return
      } else {
        this.menuDisplay.categoryId.first.current = v.id
        if (v.children && v.children.length) {
          this.secondCate = v.children
          this.thirdCate = null
        } else {
          this.secondCate = null
          this.thirdCate = null
        }
        this.searchParams['categoryId'] = v.id
        this.displayMenus.categoryId.name = v.cateName
        this.requestMenu()
      }
    },
    selectSecondCate(v) {
      if (this.menuDisplay.categoryId.second.current === v.id) {
        return
      } else {
        this.menuDisplay.categoryId.second.current = v.id
        if (v.children && v.children.length) {
          this.thirdCate = v.children
        } else {
          this.displayMenus.categoryId.name = v.cateName
          this.thirdCate = null
        }
        this.searchParams['categoryId'] = v.id
        this.displayMenus.categoryId.name = v.cateName
        this.requestMenu()
      }
    },
    selectThirdCate(v) {
      if (this.menuDisplay.categoryId.third.current === v.id) {
        return
      } else {
        this.menuDisplay.categoryId.third.current = v.id
        this.displayMenus.categoryId.name = v.cateName
        this.requestMenu()
      }
    },
    // 学科选择
    selctFirstSubject(v) {
      if (this.menuDisplay.subjects.first.current === v.id) {
        return
      } else {
        this.menuDisplay.subjects.first.current = v.id
        if (v.children && v.children.length) {
          this.secondSubject = v.children
          this.thirdSubject = null
        } else {
          this.searchParams['subjects'] = v.id
          this.displayMenus.subjects.name = v.subjectName
          this.secondSubject = null
          this.thirdSubject = null
          this.requestMenu()
        }
      }
    },
    selectSecondSubject(v) {
      if (this.menuDisplay.subjects.second.current === v.id) {
        return
      } else {
        this.menuDisplay.subjects.second.current = v.id
        if (v.children && v.children.length) {
          this.thirdSubject = v.children
        } else {
          this.searchParams['subjects'] = v.id
          this.displayMenus.subjects.name = v.subjectName
          this.thirdSubject = null
          this.requestMenu()
        }
      }
    },
    selectThirdSubject(v) {
      if (this.menuDisplay.subjects.third.current === v.id) {
        return
      } else {
        this.menuDisplay.subjects.third.current = v.id
        this.displayMenus.subjects.name = v.subjectName
        this.searchParams['subjects'] = v.id
        this.requestMenu()
      }
    },
    clean() {
      for (const key in this.menuDisplay) {
        const value = this.menuDisplay[key]
        value.current = null
        if (key === 'categoryId' || key === 'subjects') {
          value.first.current = ''
          value.second.current = ''
          value.third.current = ''
        }
      }
      for (const key in this.displayMenus) {
        this.displayMenus[key].name = ''
      }
      this.secondCate = null
      this.thirdCate = null

      this.secondSubject = null
      this.thirdSubject = null

      this.isOpened = 0
      this.searchParams = { search: '', current: 1, size: 25, sortType: 4 }
      this.requestMenu()
    },
    selectFileType(v) {
      this.currentFileType = v
      this.searchParams['resourceType'] = v.dictKey
    },
    inputChange(v) {
      this.searchParams['search'] = v.target.value
      this.$store.dispatch('search/setKeyword', v.target.value)
      this.$store.dispatch('search/setType', v.target.value)
    },
    toDetail(v) {
      const listScrollTop = document.querySelector('.digList').scrollTop
      sessionStorage.setItem(this.$options.name, listScrollTop)
      this.$router.push({
        name: 'Wapdetail',
        query: {
          rsId: v.id,
          permission: v.permissionRange
        }
      })
    },
    selectRange(v) {
      this.menuDisplay.permissionRanges.current = v.dictKey
      this.searchParams['permissionRanges'] = v.dictKey
      this.displayMenus.permissionRanges.name = v.dictValue
      this.requestMenu()
    },
    selectCopyright(v) {
      this.menuDisplay.copyrightOwner.current = v.dictKey
      this.searchParams['copyrightOwner'] = v.dictKey
      this.displayMenus.copyrightOwner.name = v.dictValue
      this.requestMenu()
    },
    selectLevel(v) {
      this.menuDisplay.collectionLevel.current = v.dictKey
      this.searchParams['collectionLevel'] = v.dictKey
      this.displayMenus.collectionLevel.name = v.dictValue
      this.requestMenu()
    }

  }
}
</script>
<style src="@/styles/wap.scss" lang="scss" scoped></style>
<style scoped>
.page{ padding-top:2.7rem !important}
.digColl,.digList{
  position: fixed;
  top:2.7rem;
  bottom:1.35rem;
  overflow: auto;
  width: 100%;
}
.digList{
  bottom:1.7rem
}
.tipsOver{
  line-height: .5rem;
  text-align: center;
  color:#999;
  font-size: .30rem;
  position: fixed;
  bottom:1.35rem;
  width:100%;
  text-align: center;
}
.none{ display: none;}

.entLabel span em {
  margin-right: 5px;
}

.entLabel span em:last-child {
  margin: 0;

}
.reqtip {
  width: 100%;
  font-size: 0.3rem;
  text-align: center;
  /* line-height: 0.6rem; */
  height: 0.6rem;
  color: #333;
}
</style>
